import { render, staticRenderFns } from "./all-suggestion-popup.vue?vue&type=template&id=2bde0732"
import script from "./all-suggestion-popup.vue?vue&type=script&lang=js"
export * from "./all-suggestion-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports